module.exports = __webpack_public_path__ + "static/img/weidian.4ab9c319.png";